export function fareFamilyFlightIdentity(journeyKey: string | undefined) {
  if (!journeyKey) return undefined
  const fareSuffix = journeyKey.indexOf('|')
  return fareSuffix === -1 ? journeyKey : journeyKey.slice(0, fareSuffix)
}

export function fareFamiliesShareFlight(currentKey: string | undefined, candidateKey: string | undefined) {
  const currentIdentity = fareFamilyFlightIdentity(currentKey)
  const candidateIdentity = fareFamilyFlightIdentity(candidateKey)
  if (!currentIdentity || !candidateIdentity) return false
  return currentIdentity === candidateIdentity
}

export function fareFamiliesForLeg<T extends { journeyKey?: string }>(
  families: Array<T>,
  legJourneyKey: string | undefined,
) {
  if (!legJourneyKey) return families
  return families.filter(family => fareFamiliesShareFlight(legJourneyKey, family.journeyKey))
}
